import { render, staticRenderFns } from "./CQThreadChat.vue?vue&type=template&id=437270ac&"
import script from "./CQThreadChat.vue?vue&type=script&lang=js&"
export * from "./CQThreadChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports